import { Employee } from '~/common/entities/Department/DepartmentTypes';

export type SelectedDay = {
  date: Date;
  employee_id: number;
};

export function updateSelection(
  employeeIdListOrderedByRowNr: number[],
  selectedDays: SelectedDay[],
  lastSelectedDay: SelectedDay | null,
  lastSelectedColumn: Date | null,
  employee: Employee | null,
  day: Date,
  ctrlDown: boolean,
  shiftDown: boolean,
): [SelectedDay[], SelectedDay | null, Date | null] {
  if (!employee) {
    return updateSelectionForColumn(
      employeeIdListOrderedByRowNr,
      selectedDays,
      lastSelectedDay,
      lastSelectedColumn,
      day,
      ctrlDown,
      shiftDown,
    );
  }
  let newLastSelectedDay: SelectedDay = {
    date: day,
    employee_id: employee.id as unknown as number,
  };
  if (!lastSelectedDay) {
    return [[newLastSelectedDay], newLastSelectedDay, lastSelectedColumn];
  }
  let newSelectedDays: SelectedDay[] = [];
  if (shiftDown) {
    const startIndex = employeeIdListOrderedByRowNr.indexOf(
      lastSelectedDay.employee_id as unknown as number,
    );
    const endIndex = employeeIdListOrderedByRowNr.indexOf(
      employee.id as unknown as number,
    );
    const [minIndex, maxIndex] = [
      Math.min(startIndex, endIndex),
      Math.max(startIndex, endIndex),
    ];

    const startDate = lastSelectedDay.date < day ? lastSelectedDay.date : day;
    const endDate = lastSelectedDay.date > day ? lastSelectedDay.date : day;

    for (let i = minIndex; i <= maxIndex; i++) {
      const emp_id = employeeIdListOrderedByRowNr[i];
      for (
        let currentDate = new Date(startDate);
        currentDate <= endDate;
        currentDate.setDate(currentDate.getDate() + 1)
      ) {
        newSelectedDays.push({
          date: new Date(currentDate),
          employee_id: emp_id!,
        });
      }
    }
    if (ctrlDown) {
      return [
        selectedDays.concat(newSelectedDays),
        newLastSelectedDay,
        lastSelectedColumn,
      ];
    } else {
      return [newSelectedDays, newLastSelectedDay, lastSelectedColumn];
    }
  } else if (ctrlDown) {
    return [
      selectedDays.concat([newLastSelectedDay]),
      newLastSelectedDay,
      lastSelectedColumn,
    ];
  } else {
    return [[newLastSelectedDay], newLastSelectedDay, lastSelectedColumn];
  }
}

function updateSelectionForColumn(
  employeeIdListOrderedByRowNr: number[],
  selectedDays: SelectedDay[],
  lastSelectedDay: SelectedDay | null,
  lastSelectedColumn: Date | null,
  day: Date,
  ctrlDown: boolean,
  shiftDown: boolean,
): [SelectedDay[], SelectedDay | null, Date | null] {
  let newSelectedDays: SelectedDay[] = [];
  if (!lastSelectedColumn) {
    newSelectedDays = employeeIdListOrderedByRowNr.map((empId) => ({
      date: day,
      employee_id: empId,
    }));
    return [newSelectedDays, lastSelectedDay, day];
  }

  if (shiftDown) {
    const startDate = lastSelectedColumn < day ? lastSelectedColumn : day;
    const endDate = lastSelectedColumn > day ? lastSelectedColumn : day;

    for (
      let currentDate = new Date(startDate);
      currentDate <= endDate;
      currentDate.setDate(currentDate.getDate() + 1)
    ) {
      employeeIdListOrderedByRowNr.forEach((empId) => {
        newSelectedDays.push({
          date: new Date(currentDate),
          employee_id: empId,
        });
      });
    }

    if (ctrlDown) {
      return [selectedDays.concat(newSelectedDays), lastSelectedDay, day];
    } else {
      return [newSelectedDays, lastSelectedDay, day];
    }
  } else {
    newSelectedDays = employeeIdListOrderedByRowNr.map((empId) => ({
      date: day,
      employee_id: empId,
    }));
    if (ctrlDown) {
      return [selectedDays.concat(newSelectedDays), lastSelectedDay, day];
    } else {
      return [newSelectedDays, lastSelectedDay, day];
    }
  }
}
